import React, { useState, useEffect } from 'react'
import { useTranslate, useRecordContext, useNotify, useRefresh } from 'react-admin'
import { ShowElement } from 'src/components/uiElements/CRUD/ShowElement'
import EventIcon from '@mui/icons-material/Event'
import TrainIcon from '@mui/icons-material/Train'
import { cloneItemReservation } from 'src/components/pages/sales/reservation/helper/cloneItemReservation'
import { afterSalesItemReservation } from 'src/components/pages/sales/reservation/helper/afterSalesItemReservation'
import { BillingStatusField } from 'src/components/pages/sales/reservation/logic/common/BillingStatusField'
import {
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  Typography,
  TableContainer,
  Table,
  TableBody,
  Button,
  TextField,
  Backdrop,
  CircularProgress,
  Tooltip,
  Checkbox,
} from '@mui/material'
import AttachMoneyIcon from '@mui/icons-material/AttachMoney'
import EditIcon from '@mui/icons-material/Edit'
import PhoneIcon from '@mui/icons-material/Phone'
import { blue } from 'src/assets/colors'
import {
  ShowCard,
  RigthSideCard,
  LeftSideCard,
  CompleteSideCard,
} from 'src/components/uiElements/cards/ShowCard'
import { Passenger } from 'src/components/pages/sales/reservation/logic/common/Passenger'
import { TrainScale } from 'src/components/pages/sales/reservation/logic/train/TrainScale'
import { TabProduct } from 'src/components/pages/sales/reservation/logic/common/TabProduct'
import { ToolbarReservation } from 'src/components/pages/sales/reservation/logic/common/ToolbarReservation'
import { handleUpdateContact } from 'src/components/pages/sales/reservation/helper/handleUpdateContact'
import { handleUpdatePricing } from 'src/components/pages/sales/reservation/helper/handleUpdatePricing'
import { ContactModal } from 'src/components/pages/sales/reservation/logic/modals/ContactModal'
import { PricingModal } from 'src/components/pages/sales/reservation/logic/modals/PricingModal'
import { LiquidationPricing } from 'src/components/pages/sales/reservation/logic/common/LiquidationPricing'
import { useCardLoading } from 'src/components/pages/sales/reservation/context/CardLoadingContext'
import { WrapperCardId } from 'src/components/pages/sales/reservation/logic/common/WrapperCardId'
import { ConfirmationDialog } from 'src/components/uiElements/styledComponents/ConfirmationDialog'
import { cancelTrainSegmentReservation } from 'src/components/pages/sales/reservation/helper/cancelTrainSegmentReservation'
import { emitItemReservation } from 'src/components/pages/sales/reservation/helper/emitItemReservation'
import { retriveItemReservation } from 'src/components/pages/sales/reservation/helper/retriveItemReservation'
import { INVOICED } from 'src/components/pages/sales/reservation/logic/common/state'
import { deleteItemReservation } from 'src/components/pages/sales/reservation/helper/deleteItemReservation'
import { TrainSegmentForm } from 'src/components/pages/sales/reservation/logic/train/TrainSegmentForm'
import { HasPermission, hasPermissionFunction } from 'src/helper/HasPermission'
import { EditOriginValues } from '../common/EditOriginValues'
import { itemServices } from 'src/services/reservation/item/item.service'
import { Comment } from '@mui/icons-material'
import { EditInputsWrap } from 'src/components/uiElements/CRUD/EditInputsWrap'
import { customAwait } from '../../helper/customAwait'
import {
  PERMISSION_GET,
  PERMISSION_IS_BILLABLE,
  PERMISSION_SHOW,
  VIEW_LIQUIDATION_RETAIL,
  VIEW_LIQUIDATION_SUPPLIER,
  VIEW_LIQUIDATION_WHOLESALER,
} from 'src/helper/Permission'

import { NotificationEmails } from 'src/components/pages/sales/reservation/logic/common/NotificationEmails'
import { FilesCard as FilesCardComponent } from '../common/FilesCard'
import { BillingAutomaticField } from '../common/BillingAutomaticField'
import { hasLiquidation, hasNotErrorInliquidation } from 'src/components/pages/sales/reservation/logic/common/hasLiquidation'
import { DueDateOfProduct } from '../common/DueDateOfProduct'
import { DUE_DATE_RANGE_PERMISSION_ENTITY } from 'src/helper/resourcesByPermission'
import { approveRefuseFraudItemReservation } from '../../helper/approveRefuseFraudItemReservation'
import { ExchangeType } from '../common/ExchangeType'
import {CommentsCardComponent} from '../common/CommentsCardComponent'
import { PostVentaStatus } from '../common/postventaStatus'
import { registerReturn } from '../../helper/registerReturn'
import { HistoryCostsDialog } from '../common/HistoryCostsDialog'
import CloseIcon from '@mui/icons-material/Close';
import { ChangeStatusDialog } from '../common/ChangeStatusDialog'
import { fontSize } from '@mui/system'
import { pricingServices } from 'src/services/reservation/pricing/pricing.service'
import { reservationServices } from 'src/services/sales/reservation/reservation.service'

const PassengerTrainSegment = ({ reservation }) => {
  const train = useRecordContext()
  const translate = useTranslate()

  const getTitularPassenger = () => {
    if (reservation?.passenger) {
      return reservation?.passenger
    } else {
      const passenger = train?.pax_relation?.find((elem) => elem.is_titular)
      return passenger ? `${passenger.name} ${passenger.surname}` : ''
    }
  }

  return <ShowElement data={getTitularPassenger()} label={translate('ra.field.passenger')} />
}

const ContextTrainSegment = () => {
  const train_segment = useRecordContext()
  const translate = useTranslate()
  if (train_segment) {
    return (
      <>
        {train_segment?.segments?.length > 0?<Box display={'flex'}>
            <LeftSideCard>
                {train_segment?.segments[0].rate_type ? <ShowElement
                  source='segments[0].rate_type'
                  label={translate('ra.field.rate_type')}
                /> : ''}
                { train_segment?.segments[0]?.conditions?.length > 0 && train_segment?.segments[0].conditions[0].name ?<ShowElement
                  source='segments[0].conditions[0].name'
                  label={translate('ra.field.booking_class')}
                /> : ''}
            </LeftSideCard>
        </Box>:''}
        <HasPermission permission={PERMISSION_SHOW} resource={DUE_DATE_RANGE_PERMISSION_ENTITY}>
          <DueDateOfProduct />
        </HasPermission>
        <TrainScale train={train_segment} />
        <Passenger itemId={train_segment.item_id} passengers={train_segment?.pax_relation} />
      </>
    )
  }
}

const ContextTrainSegmentForm = ({ reservation, openProductModal, onSubmitProduct, setOpenProductModal }) => {
  const train_segment = useRecordContext()
  if (train_segment && openProductModal) {
    return (
      <TrainSegmentForm
        openModal={openProductModal}
        reservation={reservation}
        passengers={reservation?.passengers || []}
        workUnit={reservation.work_unit_relation}
        product={train_segment}
        handleClose={() => setOpenProductModal(false)}
        onSubmit={(data, cardId) => onSubmitProduct(data, cardId)}
        recordProduct={train_segment}
      />
    )
  }
}

const ObservationsCard = () => {
  const translate = useTranslate()
  const item = useRecordContext()
  if (item && item.observations) {
    return (
      <ShowCard iconHeader={<Comment />} title={translate('ra.title.observations')} variant='text'>
        <CompleteSideCard>
          <ShowElement source='observations' onlyValue />
        </CompleteSideCard>
      </ShowCard>
    )
  }
}

const LiquidationCards = ({enableReliquidation}) => {
  const translate = useTranslate()
  const item = useRecordContext()
  const notify = useNotify()
  const refresh = useRefresh()
  const [refreshLiquidation, setRefreshLiquidation] = useState(0)
  const [openReliquidateModal, setOpenReliquidateModal] = useState(false)
  const [confirmReliquidate, setConfirmReliquidate] = useState(false)
  const [reliquidateType, setReliquidateType] = useState(0)
  const [reliquidateLoading, setReliquidateLoading] = useState(false)
  
  const onReliquidate = async () =>{
    setReliquidateLoading(true)
    if(reliquidateType === 0){
      await pricingServices.reliquidate_wholesaler([item.hash_]).then(()=>{
        setOpenReliquidateModal(false)
        setConfirmReliquidate(false)
        refresh()
        setTimeout(() => {
          setRefreshLiquidation(refreshLiquidation+1)
        }, 2000);
      }).catch(()=>{
        notify('ra.message.reliquidation_error', {type:'error'})
      }).finally(()=>{
        setReliquidateLoading(false)
      })
    }
    else if(reliquidateType === 1){
      await pricingServices.reliquidate_retail([item.hash_]).then(()=>{
        setOpenReliquidateModal(false)
        setConfirmReliquidate(false)
        refresh()
        setTimeout(() => {
          setRefreshLiquidation(refreshLiquidation+1)
        }, 2000);
      }).catch(()=>{
        notify('ra.message.reliquidation_error', {type:'error'})
      }).finally(()=>{
        setReliquidateLoading(false)
      })
    }
    else if(reliquidateType === 2){
      await pricingServices.reliquidate_supplier([item.hash_]).then(()=>{
        setOpenReliquidateModal(false)
        setConfirmReliquidate(false)
        refresh()
        setTimeout(() => {
          setRefreshLiquidation(refreshLiquidation+1)
        }, 2000);
      }).catch(()=>{
        notify('ra.message.reliquidation_error', {type:'error'})
      }).finally(()=>{
        setReliquidateLoading(false)
      })
    }
    
  }

  useEffect(()=>{
    if(confirmReliquidate){
      onReliquidate()
    }
  },[confirmReliquidate])

  const decideLiquidation = () =>{
    if(reliquidateType === 0){
      return translate('ra.title.liquidation_wholesaler')
    }
    if(reliquidateType === 1){
      return translate('ra.title.liquidation_retail')
    }
    if(reliquidateType === 2){
      return translate('ra.title.liquidation_supplier')
    }
  }

  return (
    <>
      <ExchangeType />
      {hasLiquidation(item?.pricing_relation?.[0]?.liquidation_wholesaler) && (
        <HasPermission permission={VIEW_LIQUIDATION_WHOLESALER} resource={'pricing'}>
          <ShowCard
            iconHeader={
              <Tooltip title={hasPermissionFunction('pricing', 'edit_liquidation_wholesaler') && enableReliquidation && translate('ra.action.reliquidate')}>
                <AttachMoneyIcon 
                  color={hasPermissionFunction('pricing', 'edit_liquidation_wholesaler') && enableReliquidation ? 'primary' : 'inherit'}
                  style={{cursor:hasPermissionFunction('pricing', 'edit_liquidation_wholesaler') && enableReliquidation ? 'pointer' : 'default'}}
                  onClick={async ()=>{
                    if(hasPermissionFunction('pricing', 'edit_liquidation_wholesaler') && enableReliquidation){
                      setOpenReliquidateModal(true)
                      setReliquidateType(0)
                    }
                  }}
                />
              </Tooltip>
            }
            title={translate('ra.title.liquidation_wholesaler')}
            variant='text'
            optionHeigth={'liquidation'}
          >
            <TableContainer>
              <Table>
                <TableBody key={`wholesaler${refreshLiquidation}`}>
                  <LiquidationPricing node_liquidation='liquidation_wholesaler' />
                </TableBody>
              </Table>
            </TableContainer>
          </ShowCard>
        </HasPermission>
      )}

      {hasLiquidation(item?.pricing_relation?.[0]?.liquidation_retail) &&
        hasNotErrorInliquidation(item?.pricing_relation?.[0]?.liquidation_retail) && (
          <HasPermission permission={VIEW_LIQUIDATION_RETAIL} resource={'pricing'}>
            <ShowCard
              iconHeader={<Tooltip title={hasPermissionFunction('pricing', 'edit_liquidation_retail') && enableReliquidation && translate('ra.action.reliquidate')}>
                <AttachMoneyIcon 
                  color={hasPermissionFunction('pricing', 'edit_liquidation_wholesaler') && enableReliquidation ? 'primary' : 'inherit'}
                  style={{cursor:hasPermissionFunction('pricing', 'edit_liquidation_retail') && enableReliquidation ? 'pointer' : 'default'}}
                  onClick={async ()=>{
                    if(hasPermissionFunction('pricing', 'edit_liquidation_retail') && enableReliquidation){
                      setOpenReliquidateModal(true)
                      setReliquidateType(1)
                    }
                  }}
                />
              </Tooltip>}
              title={translate('ra.title.liquidation_retail')}
              variant='text'
              optionHeigth={'liquidation'}
            >
              <TableContainer>
                <Table>
                  <TableBody key={`retail${refreshLiquidation}`}>
                    <LiquidationPricing node_liquidation='liquidation_retail' />
                  </TableBody>
                </Table>
              </TableContainer>
            </ShowCard>
          </HasPermission>
        )}

      {hasLiquidation(item?.pricing_relation?.[0]?.liquidation_supplier) && (
        <HasPermission permission={VIEW_LIQUIDATION_SUPPLIER} resource={'pricing'}>
          <ShowCard
            iconHeader={<Tooltip title={hasPermissionFunction('pricing', 'edit_liquidation_supplier') && enableReliquidation && translate('ra.action.reliquidate')}>
                <AttachMoneyIcon 
                  color={hasPermissionFunction('pricing', 'edit_liquidation_wholesaler') && enableReliquidation ? 'primary' : 'inherit'}
                  style={{cursor:hasPermissionFunction('pricing', 'edit_liquidation_supplier') && enableReliquidation ? 'pointer' : 'default'}}
                  onClick={async ()=>{
                    if(hasPermissionFunction('pricing', 'edit_liquidation_supplier') && enableReliquidation){
                      setOpenReliquidateModal(true)
                      setReliquidateType(2)
                    }
                  }}
                />
              </Tooltip>}
            title={translate('ra.title.liquidation_supplier')}
            variant='text'
            optionHeigth={'liquidation'}
          >
            <TableContainer>
              <Table>
                <TableBody key={`supplier${refreshLiquidation}`}>
                  <LiquidationPricing node_liquidation='liquidation_supplier' />
                </TableBody>
              </Table>
            </TableContainer>
          </ShowCard>
        </HasPermission>
      )}
      <ConfirmationDialog
        title={decideLiquidation()}
        contentText={translate('ra.message.reliquidation_confirm', {liquidation:decideLiquidation()})}
        buttonConfirmText={translate('ra.message.yes')}
        buttonCancel={translate('ra.message.no')}
        setOpen={setOpenReliquidateModal}
        setConfirm={setConfirmReliquidate}
        open={openReliquidateModal}
        loadingModalButton={reliquidateLoading}
      />
    </>
  )
}

const FilesCard = () => {
  const translate = useTranslate()
  const train_segment = useRecordContext()
  if (train_segment) {
    return (
      <ShowCard title={translate('ra.title.files')}>
        <FilesCardComponent recordProduct={train_segment} />
      </ShowCard>
    )
  }
}

export const TrainSegmentProduct = ({ reservation, train_segment, editMode = false }) => {
  const translate = useTranslate()
  const notify = useNotify()
  const refresh = useRefresh()
  const [open, setOpen] = useState(false)
  const [openEmitModal, setOpenEmitModal] = useState(false)
  const [openRetriveModal, setOpenRetriveModal] = useState(false)

  const [loadingRetriveItem, setLoadingRetriveItem] = useState(false)

  const [openDeleteModal, setOpenDeleteModal] = useState(false)
  const [confirmDelete, setConfirmDelete] = useState(false)
  const [loadingDeleteItem, setLoadingDeleteItem] = useState(false)

  const [nameReserve, setNameReserve] = useState('')
  const [costCancel, setCost] = useState(0)
  const [currencyCostCancel, setCurrencyCost] = useState('')
  const [costCancelLoading, setCostLoading] = useState(false)
  const [errorToCancel, setErrorToCancel] = useState(false)
  const [errorToCancelMessage, setErrorToCancelMessage] = useState('')

  const [hashItemReserve, setHashItemReserve] = useState('')

  const [confirmEmit, setConfirmEmit] = useState(false)
  const [confirmRetrive, setConfirmRetrive] = useState(false)

  const [confirmCancel, setConfirmCancel] = useState(false)
  const [loadingCancelItem, setLoadingCancelItem] = useState(false)
  const [loadingEmitItem, setLoadingEmitItem] = useState(false)

  const [openMoveModal, setOpenMoveModal] = useState(false)
  const [loadingMoveItem, setLoadingMoveItem] = useState(false)
  const [reservationNumberMove, setReservationNumberMove] = useState('')

  // const [individualRecord, setIndividualRecord] = useState({}) // sirve para pricing
  // const [openLiqudiationPricingModal, setOpenLiqudiationPricingModal] = useState(false) // sirve para pricing
  // const [loadingLiqudiationPricingModal, setLoadingLiqudiationPricingModal] = useState(false)// sirve para pricing
  const [openContactModal, setOpenContactModal] = useState(false)
  const [loadingContactModal, setLoadingContactModal] = useState(false)

  const [openPricingModal, setOpenPricingModal] = useState(false)
  const [loadingPricingModal, setLoadingPricingModal] = useState(false)
  // const [exchangeMode, setExchangeMode] = useState(false) // sirve para pricing
  const [openProductModal, setOpenProductModal] = useState(false)

  const [openFraudModal, setOpenFraudModal] = useState(false)
  const [confirmFraud, setConfirmFraud] = useState(false)
  const [approveFraud, setApproveFraud] = useState(false)
  const [loadingFraudItem, setLoadingFraudItem] = useState(false)

  const [openCloneModal, setOpenCloneModal] = useState(false)
  const [confirmClone, setConfirmClone] = useState(false)
  const [loadingCloneItem, setLoadingCloneItem] = useState(false)

  const { setCardLoading } = useCardLoading()

  const [openAfterSalesModal, setOpenAfterSalesModal] = useState(false)
  const [confirmAfterSales, setConfirmAfterSales] = useState(false)
  const [loadingAfterSalesItem, setLoadingAfterSalesItem] = useState(false)

  const [openRegisterReturnModal, setOpenRegisterReturnModal] = useState(false)
  const [confirmRegisterReturn, setConfirmRegisterReturn] = useState(false)
  const [loadingRegisterReturnItem, setLoadingRegisterReturnItem] = useState(false)

  const [wasEmitted, setWasEmitted] = useState({})

  const [historyCostsDialog, setHistoryCostsDialog] = useState()

  const [changePostVentaStatus, setChangePostventaStatus] = useState(false)
  const [loadingPostventaStatus, setLoadingPostventaStatus] = useState(false)
  const [actualStatus, setActualStatus] = useState('')

  const [changeStatusDialog, setChangeStatusDialog] = useState(false)

  const [isBillable, setIsBillable] = useState(train_segment[0].is_billable)

  const [enableReliquidation, setEnableReliquidation] = useState(false)

  useEffect(()=>{
    const items = reservation.items
    const foundItem = items.find(item=>item.id === train_segment[0].id)
    setIsBillable(foundItem.is_billable)
  },[reservation])

  useEffect(() => {
      if (confirmClone) {
        cloneItemReservation({
          hashItemReserve,
          nameReserve,
          refresh,
          notify,
          setLoadingCloneItem,
          setNameReserve,
          setHashItemReserve,
          setConfirmClone,
          setOpenCloneModal,
        })
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [confirmClone])
  
    useEffect(() => {
      if (confirmRegisterReturn) {
        registerReturn({
          hashItemReserve,
          nameReserve,
          refresh,
          notify,
          setLoadingRegisterReturnItem,
          setNameReserve,
          setHashItemReserve,
          setConfirmRegisterReturn,
          setOpenRegisterReturnModal,
        })
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [confirmRegisterReturn])

  useEffect(() => {
    if (confirmAfterSales) {
      afterSalesItemReservation({
        hashItemReserve,
        nameReserve,
        refresh,
        notify,
        setLoadingAfterSalesItem,
        setNameReserve,
        setHashItemReserve,
        setConfirmAfterSales,
        setOpenAfterSalesModal,
      })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [confirmAfterSales])

  useEffect(() => {
    if (changePostVentaStatus) {
      PostVentaStatus({
        hashItemReserve,
        nameReserve,
        refresh,
        notify,
        setLoadingPostventaStatus,
        setNameReserve,
        setHashItemReserve,
        setChangePostventaStatus,
        actualStatus
      })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [changePostVentaStatus])

  useEffect(() => {
    let wasEmittedKeys = Object.keys(wasEmitted)

    const checkWasEmitted = (without_status = false) => {
      if (
        train_segment &&
        Array.isArray(train_segment) &&
        train_segment.length > 0 &&
        wasEmittedKeys.length > 0
      ) {
        wasEmittedKeys.forEach((emit) => {
          const isEmitted = train_segment.find(
            (train_segm) => train_segm?.hash_ === emit && (without_status || train_segm?.status === INVOICED)
          )
          if (wasEmitted[emit] && isEmitted) {
            setWasEmitted((prev) => ({
              ...prev,
              [emit]: false,
            }))
            setLoadingEmitItem(false)
          }
        })
        if (without_status) {
          notify('ra.notification.emit_item_fail_reserve_error', {
            type: 'error',
            messageArgs: { reserve: nameReserve },
          })
        }
      }
    }

    const allFalse = Object.values(wasEmitted).every((value) => !value)

    let intervalId
    if (!allFalse) {
      intervalId = setInterval(() => {
        checkWasEmitted()
        refresh()
      }, 4000)
    }

    // Detiene el intervalo después de 40 segundos
    const timeoutId = setTimeout(() => {
      if (intervalId) {
        clearInterval(intervalId)
      }
      // Cambia todos los valores de wasEmitted a false
      if (!allFalse) {
        checkWasEmitted(true)
      }
    }, 40000)

    // Limpia el intervalo y el temporizador cuando el componente se desmonte
    return () => {
      if (intervalId) {
        clearInterval(intervalId)
      }
      clearTimeout(timeoutId)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [train_segment, wasEmitted])

  useEffect(() => {
    if (confirmDelete) {
      deleteItemReservation({
        hashItemReserve,
        nameReserve,
        refresh,
        notify,
        setLoadingDeleteItem,
        setNameReserve,
        setHashItemReserve,
        setConfirmDelete,
        setOpenDeleteModal,
      })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [confirmDelete])

  useEffect(() => {
    if (confirmRetrive) {
      retriveItemReservation({
        hashItemReserve,
        nameReserve,
        refresh,
        notify,
        setHashItemReserve,
        setLoadingRetriveItem,
        setNameReserve,
        setConfirmRetrive,
        setOpenRetriveModal,
      })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [confirmRetrive])

  useEffect(() => {
    if (confirmEmit) {
      emitItemReservation({
        hashItemReserve,
        nameReserve,
        refresh,
        notify,
        setHashItemReserve,
        setLoadingEmitItem,
        setNameReserve,
        setConfirmEmit,
        setOpenEmitModal,
        setWasEmitted,
        translate,
      })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [confirmEmit])

  useEffect(() => {
    if (confirmCancel) {
      cancelTrainSegmentReservation({
        hashItemReserve,
        nameReserve,
        refresh,
        notify,
        setLoadingCancelItem,
        setNameReserve,
        setHashItemReserve,
        setConfirmCancel,
        setOpen,
      })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [confirmCancel])

  useEffect(() => {
    if (confirmFraud) {
      approveRefuseFraudItemReservation({
        hashItemReserve,
        approveFraud,
        refresh,
        notify,
        setHashItemReserve,
        setLoadingFraudItem,
        setConfirmFraud,
        setOpenFraudModal
      })
      
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [confirmFraud])

  const nameReservationProduct = (product) => {
    return `${product?.segments?.[0]?.origin_name}/${product?.segments?.[0]?.arrival_name}`
  }

  const getCostToCancelTrainSegment = async (hash) => {
    try {
      setCostLoading(true)
      const constToCancel = await itemServices.cancel_item(hash)
      if (constToCancel?.refund_value && constToCancel?.currency) {
        setCost(constToCancel.refund_value)
        setCurrencyCost(constToCancel.currency)
      }
    } catch (error) {
      const error_messages = error?.response?.data?.detail || 'ra.auth.unknown'
      setErrorToCancelMessage(error_messages)
      setErrorToCancel(true)
    } finally {
      setCostLoading(false)
    }
  }

  const onSubmitProduct = (data, cardId) => {
    setCardLoading(cardId, true)
  }

  const handleMoveItem = async () => {
    if (reservationNumberMove) {
      setLoadingMoveItem(true)
      setOpenMoveModal(false)
      try {
        await itemServices.move_item(hashItemReserve, reservationNumberMove, reservation.number)
        notify('ra.notification.move_item_success', {
          type: 'success',
          messageArgs: { item: nameReserve },
        })
      } catch (error) {
        if(error.response.data?.detail){
          notify(error.response.data?.detail, {
            type: 'error',
          })
        } else {
          notify('ra.notification.move_item_error', {
            type: 'error',
            messageArgs: { item: nameReserve },
          })
        }
      } finally {
        customAwait([refresh])
        setNameReserve('')
        setHashItemReserve('')
        setReservationNumberMove('')
        setLoadingMoveItem(false)
      }
    }
  }

  const onChangeBillable = async () =>{
    const newValue = !isBillable
    setIsBillable(newValue)
    await reservationServices.updateIsBillableProduct(train_segment[0].hash_, newValue).then(()=>{
      notify('ra.notification.updated_success_masculine', {
          type: 'success',
          messageArgs: { element: translate('ra.single_entity.product') },
        })
    }).catch(()=>{
      notify('ra.notification.updated_error_masculine', {
        type: 'error',
        messageArgs: { element: translate('ra.single_entity.product') },
      })
    })
  }

  if (train_segment) {
    return (
      <>
        <Backdrop
          sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={loadingRetriveItem || loadingDeleteItem || loadingCancelItem || loadingEmitItem}
        >
          <CircularProgress color='inherit' />
        </Backdrop>

        <TabProduct
          products={train_segment}
          labelGetter={(product) => (product?.id_detail ? nameReservationProduct(product) : 'ERROR')}
          getStyle={(product) => (product?.id_detail ? null : { color: 'red' })}
        >
          {!editMode && (
            <ToolbarReservation
              resource='train-detail'
              loadingCancelItem={loadingCancelItem}
              loadingEmitItem={loadingEmitItem}
              onCancel={(train_segment) => {
                setOpen(true)
                setHashItemReserve(train_segment?.hash_)
                setNameReserve(nameReservationProduct(train_segment))
                getCostToCancelTrainSegment(train_segment?.hash_)
              }}
              onEmit={(train_segment) => {
                setOpenEmitModal(true)
                setHashItemReserve(train_segment?.hash_)
                setNameReserve(nameReservationProduct(train_segment))
              }}
              onRetrive={(train_segment) => {
                setOpenRetriveModal(true)
                setHashItemReserve(train_segment?.hash_)
                setNameReserve(nameReservationProduct(train_segment))
              }}
              onDeleted={(train_segment) => {
                setOpenDeleteModal(true)
                setHashItemReserve(train_segment?.hash_)
                setNameReserve(nameReservationProduct(train_segment))
              }}
              loadingDeleteItem={loadingDeleteItem}
              onMove={(train_segment) => {
                setOpenMoveModal(true)
                setHashItemReserve(train_segment?.hash_)
                setNameReserve(nameReservationProduct(train_segment))
              }}
              onClone={(train_segment) => {
                setOpenCloneModal(true)
                setHashItemReserve(train_segment?.hash_)
                setNameReserve(nameReservationProduct(train_segment))
              }}
              loadingMoveItem={loadingMoveItem}
              labelCancelButton={'ra.action.issuance'}
              reservation={reservation}
              setOpenProductModal={setOpenProductModal}
              onAfterSales={(train_segment)=>{
                setOpenAfterSalesModal(true)
                setHashItemReserve(train_segment?.hash_)
                setNameReserve(nameReservationProduct(train_segment))}
              }
              setLoadingMoveItem={setLoadingMoveItem}
              loadingAfterSales={loadingAfterSalesItem}
              setLoadingAfterSalesItem={setLoadingAfterSalesItem}
              onRegisterReturn={
                (train_segment)=>{
                  setOpenRegisterReturnModal(true)
                  setHashItemReserve(train_segment?.hash_)
                  setNameReserve(nameReservationProduct(train_segment))}
              }
              loadingRegisterReturn = {loadingRegisterReturnItem}
              setLoadingRegisterReturn = {setLoadingRegisterReturnItem}
              postventaStatusButton={(train_segment)=>{
                setChangePostventaStatus(true)
                setHashItemReserve(train_segment?.hash_)
                setActualStatus(train_segment.status)
              }}
              loadingPostventaStatus={loadingPostventaStatus}
            />
          )}

          <Box display={'flex'}>
            <div className='responsive-products-info'>
              <WrapperCardId>
                <ContextTrainSegmentForm
                  reservation={reservation}
                  openProductModal={openProductModal}
                  onSubmitProduct={(data, cardId) => onSubmitProduct(data, cardId)}
                  setOpenProductModal={setOpenProductModal}
                />

                <Grid container spacing={1}>
                  <Grid item xs={12} md={12} lg={12} xl={8}>
                    <ShowCard iconHeader={<EventIcon />} title={translate('ra.title.reserve_information')}>
                      <CompleteSideCard>
                        <Box display={'flex'}>
                          <LeftSideCard style={{ paddingRight: 10 }}>
                            <div style={{display:'flex', flexDirection:'row', alignItems:'center', whiteSpace:'nowrap'}}>
                              <ShowElement source='status' label={translate('ra.field.status')} />
                              <HasPermission resource={'item'} permission='edit_status'>
                                <EditIcon onClick={()=>setChangeStatusDialog(true)} style={{cursor:'pointer', fontSize:'18px', color:'#6f7ce0', marginLeft:'15px'}}/>
                              </HasPermission>
                            </div>
                            <ShowElement
                              source='created_at'
                              label={translate('ra.field.created_at')}
                              dateTime
                            />
                            <ShowElement
                              source='source_relation.short_name'
                              label={translate('ra.field.source')}
                            />
                          </LeftSideCard>
                          <RigthSideCard>
                            <ShowElement
                              source={'payment_status'}
                              label={translate('ra.field.payment_status')}
                              status
                              loading={loadingFraudItem}
                              onSelectOption={(train_segment, option) => {
                                setOpenFraudModal(true)
                                setHashItemReserve(train_segment?.hash_)
                                setApproveFraud(option === 'approve')
                              }}
                            />
                            <PassengerTrainSegment reservation={reservation} />
                            <BillingStatusField />
                            {hasPermissionFunction('item', PERMISSION_IS_BILLABLE) && (
                              <Box style={{padding: '5px 0px 5px 0px'}}>
                                <Typography
                                    variant='h7'
                                    component='span'
                                    style={{
                                      padding: '0px 5px 0px 5px',
                                      fontWeight: 600,
                                      flex: 1,
                                      maxWidth: 'fit-content'
                                    }}
                                  >
                                  {translate('ra.field.is_billable')}
                                  <Checkbox checked={isBillable} onChange={onChangeBillable}/>
                                </Typography>
                              </Box>
                            )}
                            <BillingAutomaticField />
                          </RigthSideCard>
                        </Box>
                        <Typography variant='h6' component='div' color={blue} margin={'25px 5px 10px 5px'}>
                          {translate('ra.title.provider_info')}
                        </Typography>
                        <Box display={'flex'}>
                          <LeftSideCard style={{ paddingRight: 10 }}>
                            <ShowElement
                              source='supplier_relation.name'
                              label={translate('ra.field.provider')}
                            />
                            <ShowElement
                              source='pricing_relation.[0].currency_origin'
                              label={translate('ra.field.currency')}
                            />
                          </LeftSideCard>
                          <RigthSideCard>
                            <ShowElement
                              source={'booking_reference'}
                              label={translate('ra.field.provider_code')}
                            />
                            <HasPermission resource='train-detail' permission={'show_code'}>
                              <ShowElement
                                styleValue={{fontSize:'11px'}}
                                source={'x_correlation_id'}
                                label={translate('ra.field.internal_code')}
                              />
                            </HasPermission>
                          </RigthSideCard>
                        </Box>
                      </CompleteSideCard>
                    </ShowCard>
                    <ConfirmationDialog
                      title={
                        errorToCancel
                          ? translate(errorToCancelMessage)
                          : translate('ra.message.cancel_train_segment_reserva', {
                              reserva: nameReserve,
                              cost: costCancel,
                              currency: currencyCostCancel,
                            })
                      }
                      buttonConfirmText={errorToCancel ? null : translate('ra.message.yes')}
                      buttonCancel={errorToCancel ? translate('ra.action.back') : translate('ra.message.no')}
                      setOpen={setOpen}
                      setConfirm={setConfirmCancel}
                      open={open}
                      loadingMessage={costCancelLoading}
                    />
                    <ChangeStatusDialog
                      open={changeStatusDialog}
                      setOpen={setChangeStatusDialog}
                      refresh={refresh}
                    />
                    <ConfirmationDialog
                      title={translate('ra.message.emit_item_reserva', { reserva: nameReserve })}
                      buttonConfirmText={translate('ra.message.yes')}
                      buttonCancel={translate('ra.message.no')}
                      setOpen={setOpenEmitModal}
                      setConfirm={setConfirmEmit}
                      open={openEmitModal}
                    />
                    <Dialog fullWidth maxWidth={'lg'} open={historyCostsDialog} onClose={() => setHistoryCostsDialog(false)}>
                      <DialogTitle style={{display:'flex', flexDirection:'row', width:'100%', justifyContent:'space-between'}}>{translate('ra.title.price_history')}
                        <CloseIcon style={{cursor:'pointer'}} onClick={()=>{setHistoryCostsDialog(false)}}/>
                      </DialogTitle>
                      <DialogContent>
                          <HistoryCostsDialog/>
                      </DialogContent>
                    </Dialog>
                    <ConfirmationDialog
                      title={translate('ra.message.refresh_retrive_item_reserva', { reserva: nameReserve })}
                      buttonConfirmText={translate('ra.message.yes')}
                      buttonCancel={translate('ra.message.no')}
                      setOpen={setOpenRetriveModal}
                      setConfirm={setConfirmRetrive}
                      open={openRetriveModal}
                    />
                    <ConfirmationDialog
                      title={translate('ra.message.delete_item_reserva', { item: nameReserve })}
                      buttonConfirmText={translate('ra.message.yes')}
                      buttonCancel={translate('ra.message.no')}
                      setOpen={setOpenDeleteModal}
                      setConfirm={setConfirmDelete}
                      open={openDeleteModal}
                      loadingModalButton={loadingDeleteItem}
                    />
                    <ConfirmationDialog
                      title={approveFraud ? translate('ra.message.approve_fraud') : translate('ra.message.refuse_fraud')}
                      buttonConfirmText={translate('ra.message.yes')}
                      buttonCancel={translate('ra.message.no')}
                      setOpen={setOpenFraudModal}
                      setConfirm={setConfirmFraud}
                      open={openFraudModal}
                    />
                    <ConfirmationDialog
                      title={translate('ra.message.clone_reservation', { reserva: nameReserve })}
                      buttonConfirmText={translate('ra.message.yes')}
                      buttonCancel={translate('ra.message.no')}
                      setOpen={setOpenCloneModal}
                      setConfirm={setConfirmClone}
                      open={openCloneModal}
                      loadingModalButton={loadingCloneItem}
                    />

                    <ConfirmationDialog
                      title={translate('ra.message.register_return', { reserva: nameReserve })}
                      buttonConfirmText={translate('ra.message.yes')}
                      buttonCancel={translate('ra.message.no')}
                      setOpen={setOpenRegisterReturnModal}
                      setConfirm={setConfirmRegisterReturn}
                      open={openRegisterReturnModal}
                      loadingModalButton={loadingRegisterReturnItem}
                    />

                    <ConfirmationDialog
                      title={translate('ra.message.after_sales', { reserva: nameReserve })}
                      buttonConfirmText={translate('ra.message.yes')}
                      buttonCancel={translate('ra.message.no')}
                      setOpen={setOpenAfterSalesModal}
                      setConfirm={setConfirmAfterSales}
                      open={openAfterSalesModal}
                      loadingModalButton={loadingAfterSalesItem}
                    />
                    <Dialog open={openMoveModal} onClose={() => setOpenMoveModal(false)}>
                      <DialogTitle>Mover item</DialogTitle>
                      <DialogContent>
                        <Grid container spacing={3}>
                          <EditInputsWrap
                            label={translate('ra.field.reservation_number')}
                            md={12}
                            lg={12}
                            style={{ minHeight: 0 }}
                          >
                            <TextField
                              value={reservationNumberMove}
                              onChange={(e) => setReservationNumberMove(e.target.value)}
                              size='small'
                              fullWidth
                            />
                          </EditInputsWrap>
                        </Grid>
                      </DialogContent>
                      <DialogActions>
                        <Button
                          variant='outlined'
                          onClick={() => {
                            setNameReserve('')
                            setHashItemReserve('')
                            setReservationNumberMove('')
                            setOpenMoveModal(false)
                          }}
                        >
                          Cancelar
                        </Button>
                        <Button variant='contained' onClick={handleMoveItem}>
                          Aceptar
                        </Button>
                      </DialogActions>
                    </Dialog>
                  </Grid>
                  <Grid item xs={12} md={12} lg={12} xl={4}>
                    <WrapperCardId>
                      <ContactModal
                        open={openContactModal}
                        loadingButton={loadingContactModal}
                        handleClose={() => setOpenContactModal(false)}
                        onSubmit={(record, cardId) => {
                          handleUpdateContact(
                            record,
                            cardId,
                            setLoadingContactModal,
                            setOpenContactModal,
                            notify,
                            refresh,
                            setCardLoading
                          )
                        }}
                        titleModal={translate('ra.title.update_contact')}
                      />
                      <ShowCard
                        iconHeader={<PhoneIcon />}
                        title={translate('ra.title.contanct')}
                        actionButtonIcon={!editMode && <EditIcon />}
                        variant='text'
                        onClickButton={() => {
                          setOpenContactModal(true)
                        }}
                      >
                        <CompleteSideCard>
                          <ShowElement source='contact.name' label={translate('ra.field.name')} />
                          <ShowElement source='contact.surname' label={translate('ra.field.surname')} />
                          <ShowElement source='contact.email' label={translate('ra.field.email')} />
                          <ShowElement
                            source='contact.phone_number'
                            label={translate('ra.field.phone_number')}
                          />
                        </CompleteSideCard>
                      </ShowCard>
                    </WrapperCardId>

                    <WrapperCardId>
                      <ObservationsCard />
                    </WrapperCardId>
                  </Grid>
                </Grid>
                <Grid container spacing={1}>
                  <Grid item xs={12}>
                    <ShowCard iconHeader={<TrainIcon />} title={translate('ra.title.train_information')}>
                      <CompleteSideCard style={{ display: 'block' }}>
                        <ContextTrainSegment />
                      </CompleteSideCard>
                    </ShowCard>
                  </Grid>
                </Grid>
              </WrapperCardId>
              <WrapperCardId>
                <Grid container spacing={1}>
                  <Grid item xs={12}>
                    <NotificationEmails />
                  </Grid>
                </Grid>
              </WrapperCardId>
              <HasPermission resource='file-upload' permission={PERMISSION_GET}>
                <WrapperCardId>
                  <Grid container spacing={1}>
                    <Grid item xs={12}>
                      <FilesCard />
                    </Grid>
                  </Grid>
                </WrapperCardId>
              </HasPermission>
              <HasPermission permission={PERMISSION_SHOW} resource={'comments'}>
                <WrapperCardId>
                  <Grid container spacing={1}>
                      <Grid item xs={12}>
                          <CommentsCardComponent itemId={train_segment[0]?.item_id}/>
                      </Grid>
                    </Grid>
                </WrapperCardId>
              </HasPermission>
            </div>
            <div className='responsive-products-pricing'>
              <Box
                style={{
                  position: 'sticky',
                  top: '10px',
                  zIndex: '1000',
                  '&.MuiPaper-root': {
                    overflow: 'visible !important',
                  },
                }}
              >
                <WrapperCardId>
                  <PricingModal
                    open={openPricingModal}
                    loadingButton={loadingPricingModal}
                    handleClose={() => setOpenPricingModal(false)}
                    onSubmit={(record, cardId) => {
                      handleUpdatePricing(
                        record,
                        cardId,
                        setLoadingPricingModal,
                        setOpenPricingModal,
                        notify,
                        refresh,
                        setCardLoading,
                        reservation
                      )
                    }}
                    titleModal={translate('ra.title.update_pricing')}
                  />
                  {!editMode && (
                    <div style={{display:'flex', flexDirection:'row', justifyContent:'flex-end'}}>
                      <Box display={'flex'} justifyContent={'flex-end'} alignItems={'center'}>
                        <HasPermission permission='hasEdit' resource={'pricing'}>
                            <Button
                            onClick={()=>{setHistoryCostsDialog(true)}}
                            sx={{ paddingX: '10px', marginX:'5px' }}
                            size='small'
                            variant='contained'
                            >
                            {translate('ra.title.price_history')}
                            </Button>
                        </HasPermission>
                      </Box>
                      <EditOriginValues setEnableReliquidation={setEnableReliquidation} isBillable={isBillable} setOpenPricingModal={setOpenPricingModal}/>
                    </div>
                  )}

                  {/* <LiquidationModal
                    open={openLiqudiationPricingModal}
                    loadingButton={loadingLiqudiationPricingModal}
                    handleClose={() => {
                      setOpenLiqudiationPricingModal(false)
                      setExchangeMode(false)
                    }}
                    exchange_mode={exchangeMode}
                    onSubmit={(body, cardId) => {
                      handleUpdateLiquidation(
                        individualRecord,
                        body,
                        cardId,
                        setLoadingLiqudiationPricingModal,
                        setOpenLiqudiationPricingModal,
                        notify,
                        refresh,
                        setCardLoading
                      )
                      setExchangeMode(false)
                    }}
                    titleModal={translate('ra.title.update_liquidation')}
                  /> */}
                  <LiquidationCards enableReliquidation={enableReliquidation} />
                </WrapperCardId>
              </Box>
            </div>
          </Box>
        </TabProduct>
      </>
    )
  }
}
